/* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/no-interactive-element-to-noninteractive-role --
   The table is laid out with `display: grid` (CMS-1772 R2), and Chrome and
   WebKit drop the native table semantics whenever `display` is overridden. The
   roles below look redundant against the markup but are what keeps the table in
   the accessibility tree, so they must stay. */
/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
/* eslint-disable tailwindcss/no-unnecessary-arbitrary-value */
import classNames from 'classnames';
import { IDENTITY_CELL_PADDING } from '../constants';

interface CategoryRowProps {
  categoryName: string;
  totalColumns: number;
}

export const CategoryRow = ({
  categoryName,
  totalColumns,
}: CategoryRowProps) => {
  return (
    // The table is a grid (CMS-1772 R2), so the row contributes no box of its
    // own and the empty cell spans the data tracks via `grid-column`. The span is
    // declared with `aria-colspan` rather than `colSpan`: overriding `display`
    // drops the native table semantics — which is the whole reason every role
    // below is stated explicitly — and native `colspan` is part of the same set,
    // so it would be read by nothing here.
    <tr role="row" className="contents">
      <td
        // Not a `rowheader`, unlike the identity cell. `rowheader` labels the
        // values sitting beside it in the same row, and this row has none — the
        // only other cell is the empty span below. A category is a group label
        // for the rows that follow it, which ARIA's table roles have no
        // cell-level way to say, so the honest role is the plain one.
        role="cell"
        className={classNames(
          'bg-fill/alternative-1',
          'sticky left-0 z-sticky',
          'border-t border-borders/default',
          'min-h-table/cell-min-height',
          IDENTITY_CELL_PADDING,
          'font-font-weight/table-header text-font-size/table-header leading-line-height/table-header',
          'text-text/secondary text-left break-words',
        )}
      >
        {categoryName}
      </td>
      {/* Rendered whenever there are data tracks to cover, and that is
          load-bearing rather than tidy: the rows are `display: contents`, so
          every cell in the table auto-places into one grid, and a row that
          leaves a track empty pushes every later row one track sideways. */}
      {totalColumns > 1 && (
        <td
          role="cell"
          // eslint-disable-next-line tailwindcss/no-arbitrary-value
          className="bg-fill/alternative-1 border-t border-borders/default [grid-column:2/-1]"
          aria-colspan={totalColumns - 1}
        />
      )}
    </tr>
  );
};
